import { filter, size } from 'lodash-es';
import React from 'react';
import TherapistReviews from '../Therapist/therapist_reviews';

const collectReviewsFromTherapists = therapists =>
  therapists
    .filter(therapist => therapist.reviews && therapist.reviews.length > 0)
    .reduce((acc, therapist) => acc.concat(therapist.reviews), []);

const LocationReviews = props => {
  const { therapists } = props;

  const reviews = collectReviewsFromTherapists(therapists);
  const therapistReviews = filter(
    reviews,
    r => (r.comment || r.rating) && Number(r.share_to_public) === 1,
  );
  return (
    <div className="moreInfo">
      <div className="c-reviews__items">
        {size(therapistReviews) >= 3 && (
          <TherapistReviews
            allReviews={therapistReviews}
            paginate
            titleText="What Guests are saying about our therapists"
            sharePublicOnly
          />
        )}
      </div>
    </div>
  );
};

export default LocationReviews;
